export const checkFormErrors =
  (formErrors) => !Object.keys(formErrors).every((key) => !formErrors[key]);

export const checkIncompleteForm =
  (formValues) => !Object.keys(formValues).every((key) => !!formValues[key]);
